<template>
  <div class="escape-presenting" @click.stop="handleBacktoEditor()">
    <div
      class="escape-presenting __wrapper"
      :class="{'light-text': slideActive.textColour === '#ffffff' && !isPreview}"
      v-tooltip="'Back to Editor'"
    >
      <aha-icon
        name="arrow-tail"
        viewBox="0 0 18 19"
        width="21"
        height="22"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/util'
import SlideApi from '@/api/slide'
import PresentationApi from '@/api/presentation'
import constants from '@/constant'
import Socket from '@/socket'
import Sentry from '@/services/sentry'
import gaCategories from '@/constant/gaCategories'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      isAdmin: (state) => state.isAdmin,
      sharePresentation: (state) => state.sharePresentation,
      isPreview: (state) => state.isPreview,
    }),
    conditionsUpdateLastSlide() {
      return this.presentation.id && !this.isAdmin && !this.sharePresentation
    },
  },
  methods: {
    ...mapActions(['setSyncLoadingAction']),
    handleBacktoEditor() {
      if (this.isPreview) {
        this.$emit('exitPreviewMode')
        return
      }
      // stop presenting
      utils.setCurrentWindowMode()
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.presentation.id },
      })
      if (this.slideActive.type == 'pickAnswer' && !this.isAdmin) {
        this._updateSlideQuizStatus()
      }

      if (this.conditionsUpdateLastSlide) {
        this._updatePresentationLastSlide()
      }
      utils.gaTrackEvent(
        gaCategories.PRESENTING_MODE,
        'Stop presenting button > Stop presenting',
      )
      EventBus.$emit('close-backstage-window')
      this.$store.state.isQRCodeVisible = false
    },
    async _updateSlideQuizStatus() {
      try {
        await SlideApi.updateSlideById(this.slideActive.id, {
          quizStatus: constants.QuizStatuses.LOBBY_SCREEN,
          socketId: Socket.getSocketId(),
          accessCode: this.presentation.uniqueAccessCode,
          activeSlide: this.slideActive.id,
          presentationId: this.presentation.id,
          presenting: false,
        })
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },

    _getPayloadUpdatePresentationLastSlide() {
      const idLastSlide = utils.getLastSlide(
        this.$store.state.presentation.slides,
      )
      const payload = {
        presenting: false,
        socketId: Socket.getSocketId(),
        activeSlidePreseting: this.slideActive.id,
        activeSlideAccessCode: this.presentation.uniqueAccessCode,
      }
      if (idLastSlide && idLastSlide != this.presentation.lastSlide) {
        payload.lastSlide = idLastSlide
        this.presentation.lastSlide = idLastSlide
      }
      return payload
    },

    async _updatePresentationLastSlide() {
      try {
        const payload = this._getPayloadUpdatePresentationLastSlide()
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.escape-presenting {
  position: absolute;
  cursor: pointer;
  top: 0.25rem;
  left: 0.5rem;
  font-size: 1.4rem;
  z-index: 135;
  opacity: 0;
  transition: all 0.3s ease;
  &.__wrapper {
    @apply rounded-full flex items-center justify-center w-10 h-10 bg-base-30 hover:bg-base-40;
    backdrop-filter: blur(44px);
    &.light-text {
      background-color: rgba(0, 0, 0, 0.36);
    }
    &:hover.light-text {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
